<div class="item-detail">
  @if (checklistHeader; as header) {
  <div class="summary-card">
    <div class="summary-card__media">
      <az_avatar
        [fullHeight]="true"
        [fullWidth]="true"
        [shape]="'square'"
        [src]="header.ProductModel.image"
        alt=""
      ></az_avatar>
    </div>

    <div class="summary-card__content">
      <div class="summary-card__heading">
        <h3>{{ header.ProductModel.name || '—' }}</h3>
        <span class="summary-card__type">{{ getChecklistType(header.type) }}</span>
      </div>

      <div class="summary-grid">
        <div class="summary-grid__item">
          <span class="summary-grid__label">
            {{
              header.type === 'maintenance' || header.type === 'vehicle'
                ? 'Placa'
                : 'Chassis'
            }}
          </span>
          <strong class="summary-grid__value plate">
            {{ header.chassis | uppercase }}
          </strong>
        </div>

        <div class="summary-grid__item">
          <span class="summary-grid__label">
            {{ header.type === 'maintenance' ? 'Km' : 'Horímetro' }}
          </span>
          <strong class="summary-grid__value">
            {{ header.hours_meter }}
          </strong>
        </div>

        <div class="summary-grid__item">
          <span class="summary-grid__label">Data</span>
          <strong class="summary-grid__value">
            {{ header.date | date: 'dd/MM/yyyy' }}
          </strong>
        </div>

        <div class="summary-grid__item">
          <span class="summary-grid__label">
            {{ header.type === 'maintenance' ? 'Solicitante' : 'Executor' }}
          </span>
          <strong class="summary-grid__value">
            {{ header.UserModel.name || '—' }}
          </strong>
        </div>

        @if (
          header.type === HeaderTypeEnum.TRANSFER_START ||
          header.type === HeaderTypeEnum.TRANSFER_DONE
        ) {
          <div class="summary-grid__item">
            <span class="summary-grid__label">Origem</span>
            <strong class="summary-grid__value">
              {{ header.origin?.name || 'N/A' }}
            </strong>
          </div>
          <div class="summary-grid__item">
            <span class="summary-grid__label">Destino</span>
            <strong class="summary-grid__value">
              {{ header.destination?.name || 'N/A' }}
            </strong>
          </div>
        }

        @if (header.type === HeaderTypeEnum.AUCTION) {
          <div class="summary-grid__item">
            <span class="summary-grid__label">Cliente</span>
            <strong class="summary-grid__value">
              {{ header.client_name || 'Não informado' }}
            </strong>
          </div>
          <div class="summary-grid__item">
            <span class="summary-grid__label">Email</span>
            <strong class="summary-grid__value">
              {{ header.client_email || 'Não informado' }}
            </strong>
          </div>
          <div class="summary-grid__item">
            <span class="summary-grid__label">Telefone</span>
            <strong class="summary-grid__value">
              {{ header.client_phone || 'Não informado' }}
            </strong>
          </div>
        }
      </div>

      @if (header.status === 'not_proceed') {
        <div class="not-proceed-box">
          <strong>Motivo da não procedência</strong>
          <p>{{ header.maintenance_observation || '—' }}</p>
        </div>
      }

      @if (
        header.type === HeaderTypeEnum.TRANSFER_START &&
        !header.header_request_id
      ) {
        <div class="transfer-action">
          <span class="summary-grid__label">Técnico</span>
          <div class="transfer-action__row">
            <nz-select
              nzAllowClear
              [(ngModel)]="selectedUserTarget"
              nzPlaceHolder="Escolha um usuário"
              nzShowSearch
              class="transfer-action__select"
            >
              @for (user of users; track user.id) {
                <nz-option [nzLabel]="user.name" [nzValue]="user.id"></nz-option>
              }
            </nz-select>
            <button (click)="createHeader()" nz-button nzType="primary">
              Enviar
            </button>
          </div>
        </div>
      }
    </div>
  </div>
  }

  <div class="answers-card">
    <div class="answers-card__header">
      <h3>Itens da solicitação</h3>
      <span>{{ checklistFound.length }} respostas</span>
    </div>

    <div class="answers-card__body" id="pdfData">
      <nz-table
        #table
        [nzShowPagination]="false"
        [nzData]="checklistFound"
        nzSize="middle"
        nzResponsive="true"
      >
        <thead>
          <tr>
            <th>Pergunta</th>
            <th nzWidth="140px">Resposta</th>
            <th>Observação</th>
            <th nzWidth="240px">Substituição</th>
            <th nzWidth="110px">Imagem</th>
          </tr>
        </thead>
        <tbody>
          @for (history of checklistFound; track $index) {
            <tr [class.row-replaced]="isReplaced(history)">
              <td>{{ history.ChecklistQuestionModel.question }}</td>
              <td>
                <span class="answer-pill">{{ history.answer || '—' }}</span>
              </td>
              <td class="observation-cell">
                {{ history.observation || '—' }}
              </td>
              <td>
                @if (history.ChecklistImageModels.length > 0) {
                  <div class="replace-cell">
                    @if (isReplaced(history)) {
                      <nz-tag nzColor="warning">Alterado</nz-tag>
                      <span class="replace-cell__meta">{{ replacedLabel(history) }}</span>
                    }
                    <div *hasPermission="'ADMIN'">
                      @for (image of history.ChecklistImageModels; track image.id) {
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          [id]="'replace-image-' + image.id"
                          (change)="onReplaceSelected($event, history, image)"
                        />
                      }
                      @if (history.ChecklistImageModels.length === 1) {
                        <button
                          nz-button
                          nzType="default"
                          nzSize="small"
                          type="button"
                          (click)="openReplacePicker(history.ChecklistImageModels[0].id)"
                        >
                          Substituir foto
                        </button>
                      } @else {
                        <button
                          nz-button
                          nzType="default"
                          nzSize="small"
                          type="button"
                          (click)="showModal($index)"
                        >
                          Substituir foto
                        </button>
                      }
                    </div>
                  </div>
                } @else {
                  <span class="muted">—</span>
                }
              </td>
              <td>
                @if (history.ChecklistImageModels.length > 0) {
                  <div class="image-cell">
                    <button
                      type="button"
                      class="image-link"
                      (click)="showModal($index)"
                    >
                      {{ history.ChecklistImageModels.length }}
                      {{ history.ChecklistImageModels.length === 1 ? 'foto' : 'fotos' }}
                    </button>
                  </div>
                  <nz-modal
                    [(nzVisible)]="isVisible[$index]"
                    [nzFooter]="null"
                    [nzWidth]="720"
                    [nzTitle]="
                      history.ChecklistQuestionModel.question +
                      ' - ' +
                      history.answer
                    "
                    (nzOnCancel)="handleCancel($index)"
                  >
                    <ng-container *nzModalContent>
                      <div class="image-gallery">
                        @for (image of history.ChecklistImageModels; track image.id) {
                          <div class="image-gallery__item">
                            <div class="image-gallery__photo">
                              <az_avatar
                                [src]="image.image_url"
                                [shape]="'square'"
                                [fullHeight]="true"
                                [fullWidth]="true"
                              ></az_avatar>
                            </div>
                            @if (image.replaced_at) {
                              <span class="image-gallery__meta">{{ imageReplacedLabel(image) }}</span>
                            }
                            <div *hasPermission="'ADMIN'">
                              <button
                                nz-button
                                nzType="default"
                                nzSize="small"
                                nzBlock
                                type="button"
                                (click)="openReplacePicker(image.id)"
                              >
                                Substituir
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-container>
                  </nz-modal>
                } @else {
                  <span class="muted">—</span>
                }
              </td>
            </tr>
          }
        </tbody>
        <ng-template nzNoResult>
          <nz-empty
            nzNotFoundImage="simple"
            nzNotFoundContent="Nenhum item registrado nesta solicitação"
          ></nz-empty>
        </ng-template>
      </nz-table>
    </div>
  </div>
</div>
